import BaseController from "controllers/base"
import { placesUri } from "servos/googlePlaces"
import ProjectSearchWidget from "widgets/projectSearchWidget"
import FilterForm from "servos/filterForm";
import KaminariPagination from "servos/kaminariPagination"

class Controller extends BaseController {
  call() {
    super.call()
    bindShowLinks.call(this)
    bindFilterProject.call(this)
    bindProjectSearchWidget.call(this)
    bindDeleteProject.call(this)
  }
};

let bindProjectSearchWidget = function () {
  let elem = this.root
  this.projectSearchWidget = new ProjectSearchWidget(elem)
}

let bindFilterProject = function () {
  this.filterForm = new FilterForm(this.root.find('.filtrable'))

  // this.on('select2-changed', (e) => {
  //   this.filterForm.send()
  // });

  // this.filterForm.send()
}

let bindDeleteProject = function () {
  const original = $.rails.handleMethod
  $.rails.handleMethod = function (link) {
    if (link.data('method') === 'delete') {
      link.closest('tr').css({ opacity: '0.5', pointerEvents: 'none' })
    }
    return original.call(this, link)
  }
}



let bindShowLinks = function () {
  this.root.on('click', '.project-item', (e) => {
    window.location = e.currentTarget.parentElement.dataset.url
  })
}

export default Controller;
